// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__DFov5","tuyaListBody":"tuyaListBody__75jJH"};